import { UseQueryModalReturn } from "../../types";

interface UseNumberQueryModalParams<TOperator> {
  inputValue?: number | null;
  previousValue?: number | null;
  selectedOperator: TOperator;
  initialOperator: TOperator;
}

export function useNumberQueryModal<TOperator>({
  inputValue,
  previousValue,
  selectedOperator,
  initialOperator,
}: UseNumberQueryModalParams<TOperator>): UseQueryModalReturn {
  const isSubmitDisabled =
    typeof inputValue !== "number" ||
    !selectedOperator ||
    (inputValue === previousValue && selectedOperator === initialOperator);
  return { isSubmitDisabled };
}
